import { render, staticRenderFns } from "./app.vue?vue&type=template&id=1c397983&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=1c397983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../AppPlus/H5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c397983",
  null
  
)

export default component.exports